__turbopack_context__.v({
  "error": "FormLabel-module-scss-module__UjUXaq__error",
  "label": "FormLabel-module-scss-module__UjUXaq__label",
  "root": "FormLabel-module-scss-module__UjUXaq__root",
});
